import * as PIXI from "pixi.js";
import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { MovieClipProperties } from "./MovieClipProperties";
/**
 * ButtonProperties.ts
 */
export class ButtonProperties extends AbstractViewProperties {
    constructor(id, spriteSheet, position) {
        super(position);
        this.id = id;
        this.spriteSheet = spriteSheet;
        this.textFieldOffset = new PIXI.Point(0, 0);
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.isToggle = false;
        this.movieClipProperties = new MovieClipProperties(this.id, this.spriteSheet, 4);
        this.repeat = false;
        this.disableTextAlpha = 0.2;
        this.circleRadius = 0;
        this.textRotation = 0;
        this.disableAlign = false;
        this.accessibleOptions = {};
    }
    equals(other) {
        return (super.equals(other) &&
            this.id === other.id &&
            this.spriteSheet === other.spriteSheet &&
            this.movieClipProperties.equals(other.movieClipProperties) &&
            this.isToggle == other.isToggle &&
            (this.textFieldProperties
                ? this.textFieldProperties.equals(other.textFieldProperties)
                : !other.textFieldProperties) &&
            (this.selectedTextFieldProperties
                ? this.selectedTextFieldProperties.equals(other.selectedTextFieldProperties)
                : !other.selectedTextFieldProperties) &&
            this.textFieldOffset.equals(other.textFieldOffset) &&
            this.repeat === other.repeat &&
            this.disableTextAlpha === other.disableTextAlpha &&
            this.circleRadius === other.circleRadius &&
            this.textRotation === other.textRotation &&
            this.disableAlign === other.disableAlign);
    }
}
//# sourceMappingURL=ButtonProperties.js.map